import type React from 'react';

import { Alert } from '@change/ds-core-ui/Alert';

import { Translate } from '@change-corgi/core-react/i18n';

import { useGeneralErrorMessage } from './hooks/useGeneralErrorMessage';

export const GeneralErrorMessage: React.FC<EmptyProps> = () => {
	const { data } = useGeneralErrorMessage();

	if (!data.displayed) return null;

	return (
		<Alert
			variant="error"
			data-qa="general-error-message"
			heading={<Translate value="corgi.co.promote.error.heading" />}
		>
			<Translate value="corgi.co.promote.error.description" />
		</Alert>
	);
};
